import { defineComponent as i, createBlock as n, openBlock as t, resolveDynamicComponent as l, mergeProps as p, unref as o, withCtx as f, renderSlot as r, createElementVNode as c, createTextVNode as u, toDisplayString as d } from "vue";
import { ScalarIconCaretRight as m } from "@scalar/icons";
import { cva as y, useBindCx as _ } from "@scalar/use-hooks/useBindCx";
import b from "../ScalarIcon/ScalarIconLegacyAdapter.vue.js";
const g = { class: "sr-only" }, h = {}, $ = /* @__PURE__ */ i({
  ...h,
  inheritAttrs: !1,
  __name: "ScalarSidebarGroupToggle",
  props: {
    is: { default: "div" },
    open: { type: Boolean, default: !1 },
    icon: {}
  },
  setup(v) {
    const s = y({
      base: "size-4 flex items-center justify-center transition-transform duration-100",
      variants: { open: { true: "rotate-90" } },
      defaultVariants: { open: !1 }
    }), { cx: a } = _();
    return (e, C) => (t(), n(l(e.is), p({
      type: e.is === "button" ? "button" : void 0
    }, o(a)(o(s)({ open: e.open }))), {
      default: f(() => [
        r(e.$slots, "default", { open: e.open }, () => [
          e.icon ? (t(), n(o(b), {
            key: 0,
            icon: e.icon
          }, null, 8, ["icon"])) : (t(), n(o(m), {
            key: 1,
            class: "size-3",
            weight: "bold"
          }))
        ]),
        c("span", g, [
          r(e.$slots, "label", { open: e.open }, () => [
            u(d(e.open ? "Close" : "Open") + " Group ", 1)
          ])
        ])
      ]),
      _: 3
    }, 16, ["type"]));
  }
});
export {
  $ as default
};
